import { ApolloError } from '@apollo/client';

import { LocationUpdateFormData } from '@occc-app/routes/Location/LocationUpdatePage/types';
import {
  LocationCreate,
  LocationUpdate,
  LocationCreateMutationOptions,
  SiteManagementLocationUpdateMutation,
  useSiteManagementLocationUpdateMutation,
  ClearActivityLogMutationOptions,
  useClearActivityLogMutation as useApolloClearActivityLogMutation,
  useLocationCreateMutation as useApolloLocationCreateMutation,
} from '@occc/graphql';
import { LocationCreateFormData } from '@occc-app/routes/Location/LocationCreatePage/types';

import { useMutation } from '../utils';

export const useLocationCreateMutation = (
  prepareVariables: (variables: LocationCreateFormData) => LocationCreate,
  baseOptions?: LocationCreateMutationOptions,
) => {
  const [locationCreate] = useMutation(useApolloLocationCreateMutation, baseOptions);

  return (input: LocationCreateFormData) =>
    locationCreate({
      variables: {
        locationCreateInput: prepareVariables(input),
      },
    });
};

export const useLocationUpdateMutation = (
  locationId: string,
  prepareVariables: (locationId: string, variables: LocationUpdateFormData) => LocationUpdate,
  onCompleted: (data: SiteManagementLocationUpdateMutation) => void,
  onError: (error: ApolloError) => void,
) => {
  const [locationUpdate] = useSiteManagementLocationUpdateMutation({
    onError,
    onCompleted,
  });

  return (input: LocationUpdateFormData) =>
    locationUpdate({
      variables: {
        locationUpdateInput: prepareVariables(locationId, input),
      },
      refetchQueries: ['siteManagementLocation'],
    });
};

export const useClearActivityLogMutation = (baseOptions: ClearActivityLogMutationOptions) =>
  useMutation(useApolloClearActivityLogMutation, baseOptions);
